import { getGlobalLookup } from "@faire/web--source/common/globals/lookup";
export var scopedSingletonGetter = function(InstanceConstructor) {
    var key = Symbol();
    var scopedGetter = function() {
        var singletons = getGlobalLookup()("faire.singletons");
        if (!singletons) {
            throw new Error("Cannot use singleton getter outside of React");
        }
        var _singletons_key;
        return (_singletons_key = singletons[key]) !== null && _singletons_key !== void 0 ? _singletons_key : singletons[key] = new InstanceConstructor();
    };
    return scopedGetter;
};
